import './DeleteViewButton.scss';
import classNames from 'classnames';
import { ConfirmDeleteIcon } from '@ui/modals';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { coreActions } from '@sonar-software/sonar-core';
import React from 'react';
import { useAction } from '@hooks';

export interface DeleteViewButtonProps {
	className?: string;
	viewId: number;
}

export const DeleteViewButton: React.FC<DeleteViewButtonProps> = ({ className, viewId }) => {
	const remove = useAction(coreActions.requestDeleteCoreDataDictionaryViews);

	return (
		<ConfirmDeleteIcon
			className={ classNames('view-label-delete', className) }
			getPopupContainer={ () => document.getElementsByClassName('view-selector')[ 0 ] as HTMLElement }
			onConfirm={ () => remove({ id: viewId }) }
			title={ COPY_SPECIFIC.ARE_YOU_SURE_DELETE_VIEW }
			type='outline' />
	);
};
